import {hyphenateSync as hyphenateDe} from "hyphen/de";
import {hyphenateSync as hyphenateFr} from "hyphen/fr";
import {hyphenateSync as hyphenateIt} from "hyphen/it";

function hyphenate(text: string): string {
    const lang = document.documentElement.lang;
    if (lang === 'fr') {
        return hyphenateFr(text);
    }
    if (lang === 'it') {
        return hyphenateIt(text);
    }
    return hyphenateDe(text);
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    $(window).on("load", function () {
        $('.hyphenate').each(function () {
            const originalText = $(this).text().trim();
            $(this).text(hyphenate(originalText)); // Hyphenate
            $('.upper, .lower', $(this).closest('.tile')).show(); // Show tile
        });
    });
}